import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { i18n } from "../../translate/i18n";

const ConfirmationModal = ({ title, children, open, onClose, onConfirm, showCancel = true, confirmText, cancelText, confirmDisabled = false }) => {
	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent dividers>
				{children}
			</DialogContent>
			<DialogActions>
				{showCancel && (
					<Button
						variant="contained"
						onClick={() => onClose(false)}
						color="default"
					>
						{cancelText || i18n.t("confirmationModal.buttons.cancel")}
					</Button>
				)}
				<Button
					variant="contained"
					onClick={() => {
						if (onConfirm && !confirmDisabled) {
							// Ejecutar la acción antes de onClose: varios padres (p. ej. cierre de ticket
							// en TicketListItemCustom) limpian estado/refs en onClose y el payload quedaría perdido.
							onConfirm();
							onClose(false);
						} else if (!confirmDisabled) {
							onClose(false);
						}
					}}
					color={showCancel ? "secondary" : "primary"}
					disabled={confirmDisabled}
				>
					{confirmText || i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
